import React from 'react';
import PropTypes from 'prop-types';

// Style
import './author-card.scss';

const AuthorCard = ({ img, name, desc }) => (
  <div className="author-card">
    <div className={`row ${!desc && 'flex-middle'}`}>
      <div className="col-lg-1 col-md-1 col-sm-2 col-xs-6">
        <img className="author-card-image" src={img} alt={name} />
      </div>
      <div className="col-lg-5 col-md-5 col-sm-4 col-xs-6">
        <div className="author-card-content flex-column flex-middle">
          <h5 className="author-card-title">
            Written by <span>{name}</span>
          </h5>
          {desc && <p className="author-card-description">{desc}</p>}
        </div>
      </div>
    </div>
  </div>
);

AuthorCard.defaultProps = {
  desc: '',
};

AuthorCard.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  desc: PropTypes.string,
};

export default AuthorCard;
